"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SwiperPage = _interopRequireDefault(require("../pagination/SwiperPage"));

var _SwiperRenderSize = _interopRequireDefault(require("./SwiperRenderSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Renders the Swiper.
 */
var SwiperBodyRenderer = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {SwiperInfo} info Swiper info.
   * @param {Element} element Swiper element.
   * @param {ComponentBody} body Component body.
   */
  function SwiperBodyRenderer(info, element, body) {
    _classCallCheck(this, SwiperBodyRenderer);

    this._body = body;
    this._info = info;
    this._element = element;
    this._wrapperElement = null;
    this._itemCssText = null;
  }
  /**
   * Renders the body and returns the creates pages.
   *
   * @returns {{ pages: SwiperPage[], renderSize: RenderSize }} Rendered pages.
   */


  _createClass(SwiperBodyRenderer, [{
    key: "render",
    value: function render() {
      var items = Array.from(this._body.element.children);
      this._getWrapperElement().style.width = null;

      this._setItemsElementStyle(items);

      var renderSize = this._getRenderSize(items);

      if (renderSize.pageWidth === 0) {
        return {
          pages: [],
          renderSize: renderSize
        };
      }

      if (items.length < renderSize.steps) {
        this._body.element.style.justifyContent = this._info.vertical ? null : 'center';
      } else {
        this._body.element.style.justifyContent = null;
      }

      this._setItemsElementSize(items, renderSize);

      return {
        pages: this._getPages(items, renderSize),
        renderSize: renderSize
      };
    }
    /**
     * Returns pages.
     *
     * @param {Element[]} items Items to render.
     * @param {SwiperRenderSize} renderSize Swiper size.
     * @returns {SwiperPage[]} Pages.
     */

  }, {
    key: "_getPages",
    value: function _getPages(items, renderSize) {
      var pages = [];
      var pageItems = [];
      var position = 0;

      for (var i = 0, max = items.length; i < max; i++) {
        pageItems.push(items[i]);

        if (i >= renderSize.steps - 1 && pageItems.length >= renderSize.slidesteps || pageItems.length > 0 && i === max - 1) {
          var page = new _SwiperPage.default();
          var width = pageItems.length * renderSize.itemOffsetWidth;
          var height = pageItems.length * renderSize.itemOffsetHeight;

          if (pages.length > 0) {
            if (this._info.vertical) {
              position -= height;
            } else {
              position -= width;
            }
          }

          page.elements = pageItems;
          page.position = position;
          page.size = this._info.vertical ? height : width;
          pages.push(page);
          pageItems = [];
        }
      }

      return pages;
    }
    /**
     * Returns swiper render size.
     *
     * @param {Element[]} items Swiper item elements.
     * @returns {SwiperRenderSize} Swiper render size.
     */

  }, {
    key: "_getRenderSize",
    value: function _getRenderSize(items) {
      var renderSize = new _SwiperRenderSize.default();

      var wrapperElement = this._getWrapperElement();

      renderSize.pageWidth = wrapperElement.offsetWidth;
      renderSize.pageHeight = wrapperElement.offsetHeight;

      if (items.length === 0 || renderSize.pageWidth === 0) {
        return renderSize;
      }

      var itemDimensions = this._getElementDimensions(items[0]);

      if (this._info.vertical) {
        renderSize.steps = Math.floor(renderSize.pageHeight / (itemDimensions.height + itemDimensions.marginHeight)) || 1;
      } else {
        renderSize.steps = Math.floor(renderSize.pageWidth / (itemDimensions.width + itemDimensions.marginWidth)) || 1;
      }

      renderSize.steps = renderSize.steps > items.length ? items.length : renderSize.steps;
      renderSize.itemWidth = renderSize.pageWidth / renderSize.steps - itemDimensions.marginWidth;
      renderSize.itemHeight = renderSize.pageHeight / renderSize.steps - itemDimensions.marginHeight;
      renderSize.itemOffsetWidth = renderSize.itemWidth + itemDimensions.marginWidth;
      renderSize.itemOffsetHeight = renderSize.itemHeight + itemDimensions.marginHeight;

      if (items.length < renderSize.steps) {
        renderSize.steps = items.length > 2 ? items.length : renderSize.steps - 1;
      }

      renderSize.slidesteps = renderSize.steps;

      if (this._info.steps > 0) {
        renderSize.slidesteps = this._info.steps < renderSize.steps ? this._info.steps : renderSize.steps;
      }

      return renderSize;
    }
    /**
     * Returns the wrapper element.
     *
     * @returns {Element} Wrapper element.
     */

  }, {
    key: "_getWrapperElement",
    value: function _getWrapperElement() {
      this._wrapperElement = this._wrapperElement || this._element.querySelector('.Swiper__wrapper');
      return this._wrapperElement;
    }
    /**
     * Sets page item style.
     *
     * @param {Element[]} items Elements to add style to.
     */

  }, {
    key: "_setItemsElementStyle",
    value: function _setItemsElementStyle(items) {
      for (var i = 0, max = items.length; i < max; i++) {
        if (items[i].$initialCssText !== undefined) {
          items[i].style.cssText = items[i].$initialCssText;
        } else {
          items[i].$initialCssText = items[i].style.cssText;
        }

        items[i].style.display = 'flex';
        items[i].style.flexShrink = '0';
        items[i].style.height = 'auto';
        items[i].style.whiteSpace = 'normal'; // This is a bugfix in ios for disappearing items

        items[i].style.transform = 'translateZ(0)';
      }
    }
    /**
     * Sets page item size.
     *
     * @param {Element[]} items Elements to add style to.
     * @param {RenderSize} renderSize Swiper size.
     */

  }, {
    key: "_setItemsElementSize",
    value: function _setItemsElementSize(items, renderSize) {
      for (var i = 0, max = items.length; i < max; i++) {
        items[i].style.width = this._info.vertical ? 'auto' : renderSize.itemWidth + 'px';
        items[i].style.height = this._info.vertical ? renderSize.itemHeight + 'px' : 'auto';
      }
    }
    /**
     * Returns element size.
     *
     * @param {Element} element Element to check.
     * @returns {{width: number, height: number, marginWidth: number, marginHeight: number}} Element size.
     */

  }, {
    key: "_getElementDimensions",
    value: function _getElementDimensions(element) {
      var style = window.getComputedStyle(element, null);
      return {
        width: element.offsetWidth,
        height: element.offsetHeight,
        marginWidth: this._getSizeStyle(style, 'margin-left') + this._getSizeStyle(style, 'margin-right'),
        marginHeight: this._getSizeStyle(style, 'margin-top') + this._getSizeStyle(style, 'margin-bottom')
      };
    }
    /**
     * Returns a style size property.
     *
     * @param {ComputedStyle} computedStyle Computed style.
     * @param {string} property Property name.
     * @returns {number} Size.
     */

  }, {
    key: "_getSizeStyle",
    value: function _getSizeStyle(computedStyle, property) {
      var value = parseFloat(computedStyle.getPropertyValue(property).replace('px', ''));

      if (isNaN(value)) {
        return 0;
      }

      return value;
    }
  }]);

  return SwiperBodyRenderer;
}();

exports.default = SwiperBodyRenderer;